import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from "@angular/forms";
import {IDropdownListItem} from "../../../../../shared/components/dropdown-list/dropdown-list-item";
import {IEcommerceProduct} from "../../ecommerce-product.interface";
import {ProductStockStatus} from "../../ecommerce-product.enum";
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-product-table-row',
    templateUrl: './product-table-row.component.html',
    styleUrls: ['./product-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductTableRowComponent implements OnInit {
  @Input('product') set productData(data: IEcommerceProduct) {
    if (!data) {
      return;
    }
    this.status.setValue(data.status);
    this.product = data;
  }

  @Input('websiteUrl') set websiteUrl(data: string) {
    if (!data) {
      return;
    }
    this.productUrl = `${data}/product/`;
  }
  @Input() currencySymbol: string;

  productUrl;
  @Output() removeItem: EventEmitter<number> = new EventEmitter<number>();
  @Output() duplicateItem: EventEmitter<number> = new EventEmitter<number>();
  @Output() statusChanged: EventEmitter<{ status: string; productId: number }> = new EventEmitter<{
    status: string;
    productId: number
  }>();
  product: IEcommerceProduct;
  status: FormControl = new FormControl();
  dropdownOptions: Array<IDropdownListItem> = [
    {
      action: this.onDuplicateItem.bind(this),
      label: TextUtils.getText('text_duplicate')
    },
    {
      action: this.onRemoveItem.bind(this),
      label: TextUtils.getText('text_delete')
    }
  ];
  statusOptions = [
    {
      value: 'publish',
      label: TextUtils.getText('text_active')
    },
    {
      value: 'draft',
      label: TextUtils.getText('text_draft')
    },
  ];
  readonly ProductStockStatus = ProductStockStatus;

  constructor() {
  }

  ngOnInit() {
  }

  statusChange(value) {
    this.statusChanged.emit({status: value, productId: this.product.id});
  }

  onRemoveItem() {
    this.removeItem.emit(this.product.id);
  }

  onDuplicateItem() {
    this.duplicateItem.emit(this.product.id);
  }

  get price() {
    if (this.product) {
      if (this.product.price_range && this.product.price_range.min) {
        return `${this.currencySymbol}${this.product.price_range.min} - ${this.currencySymbol}${this.product.price_range.max}`;
      }
      if (this.product.regular_price) {
        return `${this.currencySymbol}${this.product.regular_price}`;
      }

      if (this.product.price) {
        return `${this.currencySymbol}${this.product.price}`;
      }
    }
    return ''
  }
}
